export default "__VITE_ASSET__DQR97_DD__"